import { FingerPrintIcon } from "@porchpass/ui";
import { FormTable, FormTableBody, PiiFields } from "@porchpass/ui";
import * as React from "react";
import {
  ssnSchema,
  validateBankruptcyDate,
  validateDobAge,
} from "../utils/validationSchemas";
import { useApplicationFormStore } from "../hooks/useApplicationFormStore";

interface PIIFormProps {
  isCoBorrower?: boolean;
}

export const PIIForm: React.FC<PIIFormProps> = ({ isCoBorrower = false }) => {
  const store = useApplicationFormStore();
  const borrower = isCoBorrower
    ? store.data.coBorrower
    : store.data.primaryBorrower;
  const updateBorrower = isCoBorrower
    ? store.updateCoBorrower
    : store.updatePrimaryBorrower;

  const borrowerPrefix = isCoBorrower ? "coBorrower" : "primaryBorrower";
  const dobError = store.fieldErrors[`${borrowerPrefix}.dateOfBirth`];
  const ssnError = store.fieldErrors[`${borrowerPrefix}.ssn`];
  const bankruptcyDateError =
    store.fieldErrors[`${borrowerPrefix}.bankruptcyDate`];

  if (!borrower) return null;

  const handleBorrowerChange = (patch: Partial<typeof borrower>) => {
    if ("dateOfBirth" in patch && patch.dateOfBirth !== undefined) {
      if (dobError && !validateDobAge(patch.dateOfBirth)) {
        store.clearFieldError(`${borrowerPrefix}.dateOfBirth`);
      }
    }
    if ("ssn" in patch && patch.ssn !== undefined) {
      if (ssnError && ssnSchema.safeParse(patch.ssn).success) {
        store.clearFieldError(`${borrowerPrefix}.ssn`);
      }
    }
    if ("bankruptcyDate" in patch && patch.bankruptcyDate !== undefined) {
      if (
        bankruptcyDateError &&
        !validateBankruptcyDate(patch.bankruptcyDate)
      ) {
        store.clearFieldError(`${borrowerPrefix}.bankruptcyDate`);
      }
    }
    if ("hasBankruptcy" in patch && patch.hasBankruptcy === false) {
      store.clearFieldError(`${borrowerPrefix}.bankruptcyDate`);
    }
    updateBorrower(patch);
  };

  return (
    <FormTable
      title="Personally Identifiable Information"
      headerIcon={
        <FingerPrintIcon
          variant="bulk-rounded"
          size={16}
          className="text-[#BC3C7C]"
        />
      }
    >
      <FormTableBody>
        <PiiFields
          value={{
            dateOfBirth: borrower.dateOfBirth,
            ssn: borrower.ssn,
            hasBankruptcy: borrower.hasBankruptcy,
            bankruptcyDate: borrower.bankruptcyDate,
          }}
          onChange={handleBorrowerChange}
          errors={{
            dateOfBirth: dobError,
            ssn: ssnError,
            bankruptcyDate: bankruptcyDateError,
          }}
        />
      </FormTableBody>
    </FormTable>
  );
};

export default PIIForm;
